import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import { urlFor } from "~/client";

import { Button } from "@/components/ui/button";

type SsoLoginButtonProps = {
  providerName?: string;
  className?: string;
};

export default function SsoLoginButton({ providerName, className }: SsoLoginButtonProps) {
  const { t } = useTranslation("auth_sso");

  return (
    <Button asChild variant="outline" className={`w-full ${className || ""}`}>
      <a href={urlFor("sso.redirect")}>
        <ShieldCheck className="mr-2 h-4 w-4" />
        {t("continueWith", { provider: providerName || "SSO" })}
      </a>
    </Button>
  );
}
